import { useTranslation } from 'react-i18next';

import { Alert } from '@/lib/v2/components';

import { TRANSLATE_SMS_ACTION_FORM } from '@/modules/CampaignsModule/constants';

const WarningPhone = () => {
  const { t } = useTranslation();
  return (
    <Alert
      className="mt-2"
      description={t(`${TRANSLATE_SMS_ACTION_FORM}.warningPhone`)}
      type="warning"
    />
  );
};

export default WarningPhone;
